import { render, staticRenderFns } from "./VoipAudioPlayer.vue?vue&type=template&id=783d3068&"
import script from "./VoipAudioPlayer.vue?vue&type=script&lang=js&"
export * from "./VoipAudioPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VoipAudioPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports